import PlayerSettingChildBaseView from "../player_setting_childbase_view";
import ModelData from "../../../../public/model_data";
import ModuleManager from "../../../../../framework/core/module_manager";
import UserDataManager from "../../../../../manager/user_manager";

const { ccclass, property } = cc._decorator;

@ccclass
export default class PlayerKuangSettingView extends PlayerSettingChildBaseView {
    @property(cc.Label)
    playerid:cc.Label = null
    
    showHeadIcon(){
        this.playerid.string = 'ID:'+ ModelData.instance.roleData.id
        let headurl = ModelData.instance.roleData.avatar
        let module = ModuleManager.instance.getModule("PlayerInfoSetting")
        if (module != null && module.avatarUrl != ''){
            headurl = module.avatarUrl
        }
        UserDataManager.getAvatarSprite(headurl, (spr)=>{
            this.headsetting.refreshAvatar(spr)
        })
    }
 
}